import { render, staticRenderFns } from "./paciente-pronturario.vue?vue&type=template&id=7331b6a4"
import script from "./paciente-pronturario.vue?vue&type=script&lang=js"
export * from "./paciente-pronturario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports